import { createContext } from "react";
import { isBrowser } from "./isBrowser";

export const LocaleContext = createContext<string>(
  isBrowser ? window.navigator.language : "en",
);
export const LocaleProvider = LocaleContext.Provider;
